module.exports = __webpack_public_path__ + "static/media/certificate.371ee866.png";